import React, { useCallback, useRef, useEffect, useMemo } from 'react';
import theme from '../styles/theme';
import { usePostContext } from '../contexts/PostContext';

import { Header, Text, Spinner } from '../components/atoms';
import { PostForm } from '../components/molecules';
import { QuestionItem } from '../components/organisms';

const HomePage = () => {
  const {
    posts,
    isLoading,
    handleCreatePost,
    handleGetPosts: loadMore,
  } = usePostContext();
  const ref = useRef(null);

  const handlePostSubmit = useCallback(
    async (values) => {
      await handleCreatePost(values);
    },
    [handleCreatePost],
  );

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (posts?.length !== 0 && entry.isIntersecting) {
              loadMore();
            }
          });
        },
        {
          threshold: 0.5,
        },
      ),
    [loadMore, posts?.length],
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [observer]);

  return (
    <>
      <Header style={{ marginBottom: theme.spacing.xl }}>홈</Header>
      <Text style={{ marginBottom: theme.spacing.xs }}>
        멤버들에게 궁금한 것이 있다면 질문해주세요🤗
      </Text>
      <PostForm
        placeholder="질문을 입력해주세요."
        onSubmit={handlePostSubmit}
      />
      {posts
        ? posts.map((post) => <QuestionItem key={post.id} post={post} />)
        : null}
      {isLoading ? <Spinner /> : null}
      <div ref={ref} />
    </>
  );
};

export default HomePage;
